import PlainMessage from './PlainMessage'

export default PlainMessage
